import { useSelector } from "react-redux"

const MobileVideoCourse = () => {
  const theme = useSelector((state) => state.nav.theme)
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1667 5.75V2.41667C11.1667 1.49619 10.4205 0.75 9.5 0.75H2.41667C1.49619 0.75 0.75 1.49619 0.75 2.41667V9.5C0.75 10.4205 1.49619 11.1667 2.41667 11.1667H5.75M1.04167 8.375L2.53697 7.39532C3.09571 7.02925 3.81904 7.03214 4.37484 7.40267L5.44071 8.11325M3.45833 3.66667H3.875M10.5417 10.9585H10.9583M4.08333 3.66667C4.08333 3.89679 3.89679 4.08333 3.66667 4.08333C3.43655 4.08333 3.25 3.89679 3.25 3.66667C3.25 3.43655 3.43655 3.25 3.66667 3.25C3.89679 3.25 4.08333 3.43655 4.08333 3.66667ZM9.91667 9.45833V12.4583L12.25 10.9583L9.91667 9.45833ZM14.5 16.1667H7.41667C6.49619 16.1667 5.75 15.4205 5.75 14.5V7.41667C5.75 6.49619 6.49619 5.75 7.41667 5.75H14.5C15.4205 5.75 16.1667 6.49619 16.1667 7.41667V14.5C16.1667 15.4205 15.4205 16.1667 14.5 16.1667Z"
        stroke={theme === "light" ? "#434C69" : "rgba(255, 255, 255, .36)"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MobileVideoCourse
